import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from './icons/icon/icon.module';
import { SliderMenuModule } from './slider-menu/slider-menu.module';
import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomMenuOverlayContainer } from './common/cdk-overlay-container';
import { SsoLoginModule } from './sso-login/sso-login.module';
import { CdkOverlayDirective } from './common/cdk-overlay.directive';

@NgModule({
  imports: [CommonModule, IconModule, SliderMenuModule, SsoLoginModule],
  declarations: [CdkOverlayDirective],
  exports: [IconModule, SliderMenuModule, SsoLoginModule, CdkOverlayDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: OverlayContainer,
      useClass: CustomMenuOverlayContainer,
    },
  ],
})
export class DigiComponentsModule {}
